import PropTypes from "prop-types";
import RichTextInput from "../../component/richTextInput/RichTextInput";
import { stripHtmlToPlainText } from "./campaignFormHelpers.js";
import "./CampaignMessageEditor.css";

const MESSAGE_MAX_LENGTH = 1200;

export default function CampaignMessageEditor({
  value,
  onChange,
  placeholder = "Dear parents, …",
  readOnly = false,
  error = false,
  errorMessage = "",
  maxLength = MESSAGE_MAX_LENGTH,
}) {
  const plainLength = stripHtmlToPlainText(value).length;
  const isNearLimit = plainLength >= maxLength * 0.9;

  return (
    <div
      className={`campaign-message-editor${error ? " campaign-message-editor--error" : ""}`}
    >
      <div className="campaign-message-editor__header">
        <p className="campaign-message-editor__hint">
          Write the notification parents will receive. Basic formatting is
          supported.
        </p>
        {!readOnly ? (
          <span
            className={`campaign-message-editor__count${
              isNearLimit ? " campaign-message-editor__count--warning" : ""
            }`}
            aria-live="polite"
          >
            {plainLength} / {maxLength}
          </span>
        ) : null}
      </div>

      <div className="campaign-message-editor__surface">
        <RichTextInput
          className="campaign-message-editor__input"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          readOnly={readOnly}
          width="100%"
          maxLength={maxLength}
          showCharCount={false}
          error={error}
        />
      </div>

      {error && errorMessage ? (
        <p className="campaign-message-editor__error" role="alert">
          {errorMessage}
        </p>
      ) : null}
    </div>
  );
}

CampaignMessageEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  maxLength: PropTypes.number,
};
